import { duration } from "helpers/date";

import { ratingParamsParser } from "../rating-helpers";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
export function solvedTicketsParamsParser(params: any) {
  return Object.keys(params).reduce((result, key) => {
    const newKey = key === "date_from" || key === "date_to" ? `resolution_${key}` : key;
    return {
      ...result,
      [newKey]: params[key],
    };
  }, {});
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
export function parseResponseQueryParams(params: any) {
  return Object.keys(params).reduce((result, key) => {
    const newKey = key === "date_from" || key === "date_to" ? `response_${key}` : key;
    return {
      ...result,
      [newKey]: params[key],
    };
  }, {});
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
export function parseRatingQueryParams(params: any) {
  return Object.keys(params).reduce((result, key) => {
    const newKey = key === "date_from" || key === "date_to" ? `rate_${key}` : key;
    return {
      ...result,
      [newKey]: params[key],
    };
  }, {});
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
export function ticketRatingQueryParamsParser(params: any, point: any) {
  const newParams = ratingParamsParser(params, point);

  return parseRatingQueryParams(newParams);
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
export function formatDurationWithFallback(value: any) {
  return value ? duration(value) : "-";
}
